<template>
  <div style="padding: 20px">

    <div class="tip">
      <p>订单机器人将按照以下设定的流程环节自动化执行订单流程。</p>
    </div>

    <!--按钮-->
    <!--<div>-->
      <!--<el-button class="mybtn-blue2" style="width: 100px" @click="saveFlow()">保存</el-button>-->
    <!--</div>-->

    <!--标题-->
    <div class="config-title">订单流程</div>

    <!--方案列表-->
    <div v-loading="flow_loading">
      <div v-for="flow in flow_list">
        <!--<div class="wf-chose">-->
          <!--<el-checkbox :label="flow.name"-->
                       <!--v-model="flow.is_checked"-->
                       <!--@change="flow_change(flow.id)"></el-checkbox>-->
        <!--</div>-->
        <div class="wf-steps">
          <el-steps align-center>
            <el-step v-for="(step,step_idx) in flow.list" :key="step_idx" :class="step.is_unchecked?'off':''">
              <div slot="icon" style="cursor: pointer" @click="step_click(flow.id,step.code)">&nbsp;</div>
              <div slot="title" style="cursor: pointer" @click="step_click(flow.id,step.code)">{{step.value}}</div>
              <el-switch slot="title" v-show="!(step.code=='01'||step.code=='08')" v-model="step.is_unchecked" @change="step_click(step.code)" active-color="#ff4949" inactive-color="#13ce66"></el-switch>
            </el-step>
          </el-steps>
        </div>
      </div>
      <div style="height: 300px">&nbsp;</div>
    </div>

  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        flow_list: [],       // 流程列表
        flow_loading:false
      }
    },
    methods: {
      loadFlow: function () {
        let self = this
        self.flow_loading = true
        self.xFetch.post(self.xApi('/robot/order/flowplan/getPlan'), {}).then(function (res) {
          self.flow_loading = false

          if (res.data.code != '00') {
            self.xEui.msg_error(res.data.text)
            return
          }

          let flow_list = res.data.data.flowList;
          let sel_flow_id = res.data.data.type;                // 选中的流程
          let sel_steps = (res.data.data.flow || '').split(','); // 选中的步骤
          let flag=true;
          let flags=true;
          for(let i of sel_steps){
            if(i=='01'){
              flag=false
            }
            if(i=='08'){
              flags=false
            }
          }
          if(flag){
            sel_steps.push('01')
          }
          if(flags){
            sel_steps.push('08')
          }
          flow_list.forEach(function (flow) {
            flow.is_checked = flow.id == sel_flow_id ? true : false;
            flow.list.forEach(function (step) {
              if (flow.id == sel_flow_id) {
                step.is_unchecked = sel_steps.indexOf(step.code) == -1 ? true : false;
              }
              else {
                step.is_unchecked = true;
              }
            })
          })

          self.flow_list = flow_list;
        });
      },
      set_flow_val: function (fid, bol) {
        let self = this
        self.flow_list.forEach(function (flow, idx) {
          if (flow.id == fid) {
            flow.is_checked = bol;
          }
          else {
            flow.is_checked = false;
          }
          self.$set(self.flow_list, idx, flow)
        })
      },
      flow_change: function (fid) {
        let self = this
        self.flow_list.forEach(function (flow, idx) {
          if (flow.id == fid) {
            self.set_flow_val(fid, flow.is_checked || false)
          }
        })
      },
      step_click: function (fid, stepCode) {
        let self = this
        self.flow_list.forEach(function (flow, flow_idx) {
          if (flow.id == fid) {
            flow.list.forEach(function (step) {
              if (step.code == stepCode) {
                if (step.code=='01'||step.code=='08') {
                  step.is_unchecked=''
                } else {
                  step.is_unchecked = !(step.is_unchecked || false)
                }
              }
            })
            self.$set(self.flow_list, flow_idx, flow);
          }
        })

        // 选中的流程
        let flow_id = null,
          flow = null,
          flow_steps = []

        self.flow_list.forEach(function (item) {
          if (item.is_checked) {
            flow_id = item.id
            flow = item
            item.list.forEach(function (s_item) {
              if (!s_item.is_unchecked) {
                flow_steps.push(s_item.code)
              }
            })
          }
        })

//        if (!flow) {
//          self.xEui.msg_error('请选择订单流程方案')
//          return
//        }
//
//        if(!flow_steps.length){
//          self.xEui.msg_error('方案必须至少包含一个步骤')
//          return
//        }

        // save
        self.xEui.myloading('保存中...')
        self.xFetch.post(self.xApi('/robot/order/flowplan/updatePlan'), {
          type: 1,
          flow: flow_steps.join(',')
        },{xPostType:'form'}).then(function (res) {
          self.xEui.loading_close()

          if (res.data.code != '00') {
            self.xEui.msg_error(res.data.text)
          }
          else {
            self.xEui.msg_success('订单流程方案保存成功')
            self.loadFlow();
          }
        });
      },
      saveFlow: function () {
        let self = this

        // 选中的流程
        let flow_id = null,
          flow = null,
          flow_steps = []

        self.flow_list.forEach(function (item) {
          if (item.is_checked) {
            flow_id = item.id
            flow = item
            item.list.forEach(function (s_item) {
              if (!s_item.is_unchecked) {
                flow_steps.push(s_item.code)
              }
            })
          }
        })

        if (!flow) {
          self.xEui.msg_error('请选择订单流程方案')
          return
        }

        if(!flow_steps.length){
          self.xEui.msg_error('方案必须至少包含一个步骤')
          return
        }

        // save
        self.xEui.myloading('保存中...')
        self.xFetch.post(self.xApi('/robot/order/flowplan/updatePlan'), {
          type: flow_id,
          flow: flow_steps.join(',')
        },{xPostType:'form'}).then(function (res) {
          self.xEui.loading_close()

          if (res.data.code != '00') {
            self.xEui.msg_error(res.data.text)
          }
          else {
            self.xEui.msg_success('订单流程方案保存成功')
            self.loadFlow();
          }
        });
      }
    },
    created: function () {
      this.loadFlow();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mycard-title{ color: #333 }
  .el-input, .el-select, .el-date-editor.el-input{
    width: 220px;
  }
  .el-textarea{
    width: 370px;
  }
  .my-checkbox{
    margin: 0;
    margin-right: 30px;
  }
  /*config-title*/
  .config-title{ font-size: 13px;color: #333;font-weight: 700;padding: 30px 0; }
  /*mydialog_add_order_group*/
  .mydialog_add_order_group{ }
  .mydialog_add_order_group .dg-input{ width: 220px }
  .mydialog_add_order_group .dg-desc{ font-size: 13px;color: #909399; }
  p{
    margin: 0;
  }
  .subtitle{
    font-size: 15px;
    font-weight: bold;
    margin-right: 20px;
  }
</style>
<style>
  /*方案选择*/
  .wf-chose{ padding: 20px 0px 20px 0px }
  .wf-chose .el-checkbox__input.is-checked+.el-checkbox__label{ color: #606266 }
  .wf-steps{ padding: 0px 50px  }
  .wf-steps .el-step__title{ color: #606266 !important;font-weight: normal !important;font-size: 14px;}
  .wf-steps .el-step__icon{ width: 25px;height: 25px;border-color:#409EFF;overflow: hidden;position: relative;top: 5px }
  .wf-steps .el-step__line{background-color:rgba(0,0,0,0.04)}
  .wf-steps .el-step.off .el-step__icon{ border-color:#eeeeee  }
  /*mydialog_add_order_group*/
  .mydialog_add_order_group .el-dialog__body{ padding: 20px;padding-bottom: 0 }
  .mydialog_add_order_group .el-form-item{ margin-bottom: 10px }
</style>



// WEBPACK FOOTER //
// src/views/config/strategy/order-work-flow.vue